<template>
	<Swiper
		v-if="!isLoading && eventRiseData && eventRiseData.event_rise.length > 0"
		class="container"
		v-bind="mainSwiperOptions"
	>
		<SwiperSlide v-for="(item, index) in eventRiseData?.event_rise" :key="`${index}`" class="container_item">
			<div class="name">
				<span class="name_master">
					{{ item.master_name }}
				</span>
				<LineIcon v-if="displayStore.isDesktop" />
				<span class="name_company">
					{{ item.event_name }}
				</span>
			</div>
			<div class="content">
				<div class="content_price">
					<span>기준가</span>
					<div class="lock_img">
						<img src="@/assets/img/common/white_lock.svg" alt="잠금장치 아이콘" loading="lazy" />
					</div>
				</div>
				<div class="content_percent">
					<span>상승률</span>
					<div class="percent">
						<span>{{ item.event_rise_ratio }}%</span>
					</div>
				</div>
			</div>
		</SwiperSlide>
	</Swiper>
</template>
<script setup lang="ts">
//swiper
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/vue';

import { useGetEventRiseApi } from '@/api/event';
import LineIcon from '@/assets/img/common/line.svg?component';
import { useDisplayStore } from '@/stores/display';

const displayStore = useDisplayStore();
const { data: eventRiseData, isLoading } = useGetEventRiseApi();
const mainSwiperOptions = {
	modules: [Autoplay, Pagination, Navigation],
	autoplay: {
		delay: 4500,
		disableOnInteraction: false,
	},
	slidesPerView: 'auto',
	direction: 'vertical',
	freeMode: false,
	observer: true,
	observeParents: true,
	updateOnWindowResize: true,
	loop: true,
};

//TODO:추후 연결 예정
// const onClickPrice = async () => {
// 	if (!tokenStore.isLogin) {
// 		checkLoginDetail();
// 		return;
// 	}
// 	const res = await checkAuthRefetch();
// 	if (!res.data?.success) {
// 		modalStore.openModal('GuideModal');
// 		return;
// 	}
// };
</script>

<style lang="scss" scoped>
.container {
	width: 100%;
	height: 4rem;
	@media screen and (max-width: 1280px) {
		height: 5.4rem;
	}
	// background-color: var(--color-bg-mid);
	border-radius: var(--border-radius-xx-small);
	&_item {
		display: flex;
		align-items: center;
		gap: 3.2rem;
		font-size: var(--font-s-small);
		font-weight: var(--font-w-semi-bold);
		line-height: normal;
		padding: 1rem 0rem;
		@media screen and (max-width: 1280px) {
			justify-content: space-between;
		}
		.name {
			display: flex;
			align-items: center;
			gap: 0.8rem;
			font-size: var(--font-s-small);
			line-height: normal;
			@media screen and (max-width: 1280px) {
				flex-direction: column;
				gap: 0.2rem;
				align-items: flex-start;
			}

			&_master {
				font-weight: var(--font-w-light);
			}
			&_company {
				font-weight: var(--font-w-semi-bold);
			}
		}
		.content {
			display: flex;
			gap: 3.2rem;
			@media screen and (max-width: 1280px) {
				gap: 1.6rem;
			}
			&_price {
				display: flex;
				flex-direction: row;
				align-items: center;
				gap: 0.4rem;
				// cursor: pointer;
				.lock_img {
					display: flex;
					align-items: center;
					justify-content: center;
					width: 4.5rem;
					height: 2.4rem;
					border-radius: var(--border-radius-full);
					background-color: var(--color-base-mid);
					img {
						width: 1.1rem;
					}
				}
			}
			&_percent {
				display: flex;
				flex-direction: row;
				align-items: center;
				gap: 0.4rem;
			}
			.percent {
				display: flex;
				align-items: center;
				justify-content: center;
				padding: 0.4rem 0.8rem;
				border-radius: var(--border-radius-full);
				background-color: var(--color-danger);
			}
		}
	}
}
</style>
